import { SiteIdOverrideConfig } from "stores/wizard/config";
import { timeValues24HoursFormat } from "src/components/shared/TimeDropdown/config/time/timeValues";
import { DayName } from "uitk-react-date-picker";

export const siteId70914: SiteIdOverrideConfig = {
  package: {
    showAllSubLOB: false,
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
  car: {
    location: {
      destination: {
        inputName: "returnName",
      },
      origin: {
        inputName: "pickupName",
      },
    },
    date: {
      queryParam: {
        start: "",
        end: "",
      },
      firstDayOfWeek: DayName.MON,
    },
    form: {
      action: "https://car-rental.expedia.com.sg/{locale}-sg/book#/vehicles",
    },
    timeValues: timeValues24HoursFormat,
    defaultShowingTime: "10:30",
    isCarTrawler: true,
    showVendorOptions: false,
    clientID: 381124,
    residenceID: "SG",
    includeGT: false,
  },
  hotel: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
    packageRatesTermsUrl: "/static/default/default/taap/contracts/hpr/SG.HPR.012021.pdf",
  },
  flight: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
  lx: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
};
